import React from "react";
import Modal from "../Modal/modal";
import "./talkToUsModal.scss";
import { getWaitText } from "../../utils/helperFunctions";

const TalkToUsModal = ({ isOpen, onClose, data }) => {
  const {
    webSubDesc,
    webDesc,
    phoneNumber,
    isAvailable,
  } = data;

  const waitText = getWaitText(data);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="talk-to-us-modal">
        <p className="heading">Talk To Us</p>

        <div className="tele-number-wrapper">
          <p className="tele-number">{phoneNumber}</p>
          {waitText ? (
            <p
              className={`wait-time-wrapper ${
                isAvailable ? "" : "disabled"
              }`}
            >
              {waitText}
            </p>
          ) : null}
        </div>
        {webDesc ? <p className="desc">{webDesc}</p> : null}
        {webSubDesc ? (
          <p className="desc">{webSubDesc}</p>
        ) : null}
      </div>
    </Modal>
  );
};

export default TalkToUsModal;
